import React, { useState } from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import TextWithTooltip from '../../../../components/text-with-tooltip/text-with-tooltip';
import TextField from '../../../../components/form/text-field/text-field';
import FormSelectField from '../../../../components/form/select-field';
import { getInDialServiceNumberList } from '../../ssm-homepage.actions';
import FormError from '../../../../components/form/error/error';
import {
  PORT_TYPE_P_PHONE,
  PORT_TYPE_ANALOG,
  PORT_TYPE_MOBILE,
} from '../../../../app-constants';
import { Desktop, Mobile } from '../../../../app-responsive';

import Accordion from '../../../../components/accordion/accordion';
import './indial-number-detail-table.css';

const InDialNumberDetailTable = (props) => {
  const {
    noteToFillNumberOfDevices,
    incompleteTableError,
    intendedUseLabelTooltip,
    intendedUseLabel,
    serviceNumberLabel,
    serviceNumberTooltip,
    userFirstNameLabel,
    userFirstNameTooltip,
    userLastNameLabel,
    userLastNameTooltip,
    userOrNumberTypeLabel,
    userOrNumberTypeTooltip,
    deskPhoneText,
    librateMobileText,
    analogueDevicesText,
    analogueDevicesUserTypeText,
    formFields,
  } = props.authorableContent;

  const {
    isMigrationCountZero,
    inDialNumberDetailingData,
    migrationCounts,
    siteId,
    handleOnSelectionChange,
    handleUserNameOnChange,
    handleUserNameOnBlur,
    handleUserTypeOnChange,
    serviceNumberData,
    userNamesData,
    userTypeData,
    handleOnSelectionBlur,
    tableError,
    isdnInDialTiptServiceMigrateCancelCheckList,
  } = props;

  const [currentPage, setCurrentPage] = useState(0);

  const deskPhoneCount = migrationCounts[`${siteId}-${PORT_TYPE_P_PHONE}`] !== undefined ?
    Array.from({ length: migrationCounts[`${siteId}-${PORT_TYPE_P_PHONE}`] }, (v, i) => i) : [];
  const mobileCount = migrationCounts[`${siteId}-${PORT_TYPE_MOBILE}`] !== undefined ?
    Array.from({ length: migrationCounts[`${siteId}-${PORT_TYPE_MOBILE}`] }, (v, i) => i) : [];
  const analogCount = migrationCounts[`${siteId}-${PORT_TYPE_ANALOG}`] !== undefined ?
    Array.from({ length: migrationCounts[`${siteId}-${PORT_TYPE_ANALOG}`] }, (v, i) => i) : [];

  const numberList = getInDialServiceNumberList(inDialNumberDetailingData, isdnInDialTiptServiceMigrateCancelCheckList, siteId);
  const numberListOptions = numberList.map(number => (
    {
      id: number,
      serviceNumber: number,
    }
  ));

  const handlePageChange = (event, index) => {
    event.preventDefault();
    const pagesCount = Math.ceil((deskPhoneCount.length + mobileCount.length + analogCount.length) / 20);
    if (index >= 0 && index <= pagesCount - 1) {
      setCurrentPage(index);
    }
  };

  const getUserNamesValues = (elementId, placeHolderValue) => (userNamesData[elementId] !== undefined ? userNamesData[elementId] : placeHolderValue);

  const userNamesErrorPresent = elementId => (userNamesData[elementId] !== undefined && userNamesData[elementId].trim().length === 0);

  const getServiceNumberValues = (elementId) => {
    const selectedValueArray = [];
    if (serviceNumberData && serviceNumberData[elementId] !== undefined) {
      selectedValueArray.push({
        id: serviceNumberData[elementId],
        serviceNumber: serviceNumberData[elementId],
      });
      return selectedValueArray;
    }
    return null;
  };

  const serviceNumberHasError2 = (elementId) => {
    const serviceNumberValues = Object.values(serviceNumberData);
    if (serviceNumberValues.length > 0) {
      const duplicateValuesPresent = serviceNumberValues.filter(item => item === serviceNumberData[elementId]);
      return duplicateValuesPresent.length > 1;
    }
    return false;
  };

  const isServiceNumberInValid = elementId => (serviceNumberData[elementId] !== undefined
    && numberList.includes(serviceNumberData[elementId].trim()) === false);

  const serviceNumberInComplete = elementId => (serviceNumberData[elementId] !== undefined && serviceNumberData[elementId].trim().length < 8);

  const getUserTypeValueFromKey = key => (formFields.userOrNumberType.options.filter(option => option.key === key)[0].value);

  const defaultValueUserType = formFields.userOrNumberType.options.filter(option => option.key === 'notapplicable')[0].value;

  const desktopgeneratePhoneRows = (deviceType, deviceLabel, devicesList, userStartCount, isUserTypePresent) => devicesList.map((item, index) => (
    <div className="row" key={`${deviceType} ${item}`}>
      <div className={`col-2 device-label ${deviceType}`}>
        {deviceLabel}
      </div>
      <div className="col-3">
        <Typeahead
          id={`${siteId}-${deviceType}-servicenumber-${index + 1}`}
          labelKey="serviceNumber"
          inputProps={{ 'aria-label': `${siteId}-${deviceType}-servicenumber-${index + 1}` }}
          className={`text-field ${serviceNumberHasError2(`${siteId}-${deviceType}-servicenumber-${index + 1}`) ? 'has-error' : ''}`}
          options={numberListOptions}
          maxResults={20}
          paginationText="Load more..."
          placeholder={formFields.serviceNumber.placeholder}
          onChange={handleOnSelectionChange}
          onBlur={handleOnSelectionBlur}
          selected={getServiceNumberValues(`${siteId}-${deviceType}-servicenumber-${index + 1}`)}
        />
        {(serviceNumberHasError2(`${siteId}-${deviceType}-servicenumber-${index + 1}`)
          || serviceNumberInComplete(`${siteId}-${deviceType}-servicenumber-${index + 1}`)
          || isServiceNumberInValid(`${siteId}-${deviceType}-servicenumber-${index + 1}`))
          && <FormError errorText={formFields.serviceNumber.errorText} /> }

      </div>
      <div className="col-2">
        <TextField
          id={`${siteId}-${deviceType}-firstname-${index + 1}`}
          value={getUserNamesValues(`${siteId}-${deviceType}-firstname-${index + 1}`,
            `${formFields.userFirstName.placeholder}`)}
          onChange={handleUserNameOnChange}
          onBlur={handleUserNameOnBlur}
        />
        {userNamesErrorPresent(`${siteId}-${deviceType}-firstname-${index + 1}`) && <FormError errorText={formFields.userFirstName.errorText} /> }
      </div>
      <div className="col-2">
        <TextField
          id={`${siteId}-${deviceType}-lastname-${index + 1}`}
          value={getUserNamesValues(`${siteId}-${deviceType}-lastname-${index + 1}`,
            `${formFields.userLastName.placeholder} ${userStartCount + index + 1}`)}
          onChange={handleUserNameOnChange}
          onBlur={handleUserNameOnBlur}
        />
        {userNamesErrorPresent(`${siteId}-${deviceType}-lastname-${index + 1}`) && <FormError errorText={formFields.userLastName.errorText} /> }
      </div>
      <div className="col-3">
        {isUserTypePresent && (
          <FormSelectField
            id={`${siteId}-${deviceType}-usertype-${index + 1}`}
            label=""
            disabled={false}
            onBlur={handleUserTypeOnChange}
            value={userTypeData[`${siteId}-${deviceType}-usertype-${index + 1}`] !== undefined ?
              getUserTypeValueFromKey(userTypeData[`${siteId}-${deviceType}-usertype-${index + 1}`]) : defaultValueUserType}
            options={formFields.userOrNumberType.options}
            sendKeyValueOnChange
          />
        )}
        {isUserTypePresent === false &&
          <span className="analog-user-type-text">{analogueDevicesUserTypeText}</span>
        }
      </div>
    </div>
  ));

  const mobilegeneratePhoneRows = (deviceType, deviceLabel, devicesList, userStartCount, isUserTypePresent) => devicesList.map((item, index) => (
    <div className="row" key={item}>
      <Accordion
        accordionWrapperClass="col-12"
        onLoadcollapse
        onClickOnFullAccordionWidth
        headerComponent={
          <React.Fragment>
            <span className="header-text">{deviceLabel}</span>
            <i className="td-icon icon-ui-down-arrow-thick" />
          </React.Fragment>
        }
      >
        <div className="arrowdesign" />
        <div className="table-content">
          {serviceNumberLabel}
          <TextWithTooltip
            text={<i className="td-icon icon-help" />}
            textClassName="help-icon-container"
            id="indial-number-detail-table-intended-use-tooltip"
            toolTipText={serviceNumberTooltip}
          />
          <Typeahead
            id={`${siteId}-${deviceType}-servicenumber-${index + 1}`}
            labelKey="serviceNumber"
            inputProps={{ 'aria-label': `${siteId}-${deviceType}-servicenumber-${index + 1}` }}
            className="text-field"
            options={numberListOptions}
            maxResults={20}
            paginationText="Load more..."
            placeholder={formFields.serviceNumber.placeholder}
            onChange={handleOnSelectionChange}
            selected={getServiceNumberValues(`${siteId}-${deviceType}-servicenumber-${index + 1}`)}
          />
        </div>
        <div className="table-content">
          {userFirstNameLabel}
          <TextWithTooltip
            text={<i className="td-icon icon-help" />}
            textClassName="help-icon-container"
            id="indial-number-detail-table-service-number-tooltip"
            toolTipText={userFirstNameTooltip}
          />
          <TextField
            id={`${siteId}-${deviceType}-firstname-${index + 1}`}
            value={getUserNamesValues(`${siteId}-${deviceType}-firstname-${index + 1}`,
              `${formFields.userFirstName.placeholder}`)}
            onChange={handleUserNameOnChange}
            onBlur={handleUserNameOnBlur}
          />
          {userNamesErrorPresent(`${siteId}-${deviceType}-firstname-${index + 1}`) && <FormError errorText={formFields.userFirstName.errorText} /> }
        </div>
        <div className="table-content">
          {userLastNameLabel}
          <TextWithTooltip
            text={<i className="td-icon icon-help" />}
            textClassName="help-icon-container"
            id="indial-number-detail-table-first-name-tooltip"
            toolTipText={userLastNameTooltip}
          />
          <TextField
            id={`${siteId}-${deviceType}-lastname-${index + 1}`}
            value={getUserNamesValues(`${siteId}-${deviceType}-lastname-${index + 1}`,
              `${formFields.userLastName.placeholder} ${userStartCount + index + 1}`)}
            onChange={handleUserNameOnChange}
            onBlur={handleUserNameOnBlur}
          />
          {userNamesErrorPresent(`${siteId}-${deviceType}-lastname-${index + 1}`) && <FormError errorText={formFields.userLastName.errorText} /> }
        </div>
        {isUserTypePresent && (
          <div className="table-content">
            {userOrNumberTypeLabel}
            <TextWithTooltip
              text={<i className="td-icon icon-help" />}
              textClassName="help-icon-container"
              id="indial-number-detail-table-user-number-tooltip"
              toolTipText={userOrNumberTypeTooltip}
            />
            <FormSelectField
              id={`${siteId}-${deviceType}-usertype-${index + 1}`}
              label=""
              disabled={false}
              onBlur={handleUserTypeOnChange}
              value={userTypeData[`${siteId}-${deviceType}-usertype-${index + 1}`] !== undefined ?
                getUserTypeValueFromKey(userTypeData[`${siteId}-${deviceType}-usertype-${index + 1}`]) : 'Not Applicable'}
              options={formFields.userOrNumberType.options}
              sendKeyValueOnChange
            />
          </div>
        )}
        {isUserTypePresent === false &&
          <span className="analog-user-type-text">{analogueDevicesUserTypeText}</span>
        }
      </Accordion>
    </div>
  ));

  const pageSize = 20;
  const pagesCount = Math.ceil((deskPhoneCount.length + mobileCount.length + analogCount.length) / pageSize);

  const generateDesktopPageData = () => {
    let fullDataArray = [];
    fullDataArray = [...desktopgeneratePhoneRows(PORT_TYPE_P_PHONE, deskPhoneText, deskPhoneCount, 0, true),
      ...desktopgeneratePhoneRows(PORT_TYPE_MOBILE, librateMobileText, mobileCount, deskPhoneCount.length, true),
      ...desktopgeneratePhoneRows(PORT_TYPE_ANALOG, analogueDevicesText, analogCount, deskPhoneCount.length + mobileCount.length, false)];

    return fullDataArray.slice(currentPage * pageSize, (currentPage + 1) * pageSize);
  };

  const generateMobilePageData = () => {
    let fullDataArray = [];
    fullDataArray = [...mobilegeneratePhoneRows(PORT_TYPE_P_PHONE, deskPhoneText, deskPhoneCount, 0, true),
      ...mobilegeneratePhoneRows(PORT_TYPE_MOBILE, librateMobileText, mobileCount, deskPhoneCount.length, true),
      ...mobilegeneratePhoneRows(PORT_TYPE_ANALOG, analogueDevicesText, analogCount, deskPhoneCount.length + mobileCount.length, false)];
    return fullDataArray.slice(currentPage * pageSize, (currentPage + 1) * pageSize);
  };

  return (
    <div className="indial-number-detail-table">
      {tableError &&
        <FormError errorText={incompleteTableError} />
      }
      <div className="row headings hidden-mobile">
        <div className="col-2">
          {intendedUseLabel}
          <TextWithTooltip
            text={<i className="td-icon icon-help" />}
            textClassName="help-icon-container"
            id="indial-number-detail-table-intended-use-tooltip"
            toolTipText={intendedUseLabelTooltip}
          />
        </div>
        <div className="col-3">
          {serviceNumberLabel}
          <TextWithTooltip
            text={<i className="td-icon icon-help" />}
            textClassName="help-icon-container"
            id="indial-number-detail-table-service-number-tooltip"
            toolTipText={serviceNumberTooltip}
          />
        </div>
        <div className="col-2">
          {userFirstNameLabel}
          <TextWithTooltip
            text={<i className="td-icon icon-help" />}
            textClassName="help-icon-container"
            id="indial-number-detail-table-first-name-tooltip"
            toolTipText={userFirstNameTooltip}
          />
        </div>
        <div className="col-2">
          {userLastNameLabel}
          <TextWithTooltip
            text={<i className="td-icon icon-help" />}
            textClassName="help-icon-container"
            id="indial-number-detail-table-last-name-tooltip"
            toolTipText={userLastNameTooltip}
          />
        </div>
        <div className="col-3">
          {userOrNumberTypeLabel}
          <TextWithTooltip
            text={<i className="td-icon icon-help" />}
            textClassName="help-icon-container"
            id="indial-number-detail-table-user-number-tooltip"
            toolTipText={userOrNumberTypeTooltip}
          />
        </div>
      </div>
      {isMigrationCountZero &&
        <div className="row hidden-mobile">
          <div className="col-12">
            {noteToFillNumberOfDevices}
          </div>
        </div>
      }
      <Desktop>
        {[...generateDesktopPageData()]}
      </Desktop>
      <Mobile>
        {[...generateMobilePageData()]}
      </Mobile>
      {(deskPhoneCount.length + mobileCount.length + analogCount.length) > 0 &&
        <div className="row pagination-wrapper">
          <Pagination aria-label="number-detailing-pagination">
            <PaginationItem className="nav-item" disabled={currentPage <= 0}>
              <PaginationLink
                onClick={e => handlePageChange(e, currentPage - 1)}
                previous
                href="#"
              />
            </PaginationItem>
            {[...Array(pagesCount)].map((page, i) => (
              <PaginationItem className="nav-item" active={i === currentPage} key={`${page} PageArray`}>
                <PaginationLink onClick={e => handlePageChange(e, i)} href="#">
                  {i + 1}
                </PaginationLink>
              </PaginationItem>
            ),
            )}
            <PaginationItem className="nav-item" disabled={currentPage >= pagesCount - 1}>
              <PaginationLink
                onClick={e => handlePageChange(e, currentPage + 1)}
                next
                href="#"
              />
            </PaginationItem>
          </Pagination>
        </div>
      }
    </div>
  );
};

export default InDialNumberDetailTable;
